<script>
    import _ from 'lodash';
    import {onDestroy, onMount} from 'svelte';
    import {Link} from 'svelte-routing';
    import {network, store} from '../stores.js';
    import TopMenu from '../components/TopMenu.svelte';
    import {dataURLtoBlob, resizeImage} from "../helpers";

    export let id;

    const user = store('credential', 'getAuth');
    const axis = store('axis', '', false);

    let text = '',
        disabled = false,
        messages = [],
        message_last_id = 0,
        refreshTimer = null;

    // self refresh function
    (async function refreshChatMessages (order_id, user_id) {
        clearTimeout(refreshTimer);

        let buf = await network.getChatMessages(order_id, user_id, message_last_id);

        if (buf.length) {
            setTimeout(() => window.scrollTo(0, document.body.scrollHeight), 150);

            messages = [...messages, ...buf];
            message_last_id = buf[buf.length - 1].id;
        }

        if (disabled) {
            disabled = false;
            text = '';
        }

        refreshTimer = setTimeout(async () => refreshChatMessages(order_id, user_id), 2000);
    })(id, $user.id);

    // clear refresh function
    onDestroy(() => clearTimeout(refreshTimer));

    // subscribe notify
    onMount(() => {
        if (typeof Notification !== 'undefined' && Notification.permission !== 'granted') {
            // window.notify_subscribe();
        } else {
            let params = JSON.parse(localStorage.getItem('params') ?? '');

            if (params && params.token) {
                // hack для android app
                network.sendChatToken(params.token);
            }
        }
    })

    const sendAttachment = async (e) => {
        let el = e.currentTarget,
            fd = new FormData();

        if (!disabled && el && el.files && el.files[0]) {
            disabled = true;

            for (let i = 0; i < el.files.length; i++) {
                switch (el.id) {
                    case 'picture': {
                        let resizedBlob = dataURLtoBlob(await resizeImage(el.files[i]));

                        fd.append('files[]', resizedBlob, el.files[i].name);
                        break;
                    }

                    case 'file': {
                        fd.append('files[]', el.files[i]);
                        break;
                    }
                }
            }

            let result = await network.cdn(fd);

            if (result && result.length) {
                let order_id = +id,
                    user_id = +$user.id,
                    user_name = $user.name;

                await network.sendChatMessage(
                    order_id,
                    user_id,
                    user_name,
                    result.map((el) => el.url_direct).join(';'),
                    el.id
                );
            }
        }

        el.value = '';
    }

    const sendTextMessage = async () => {
        let order_id = +id,
            user_id = +$user.id,
            user_name = $user.name;

        if (!disabled) {
            disabled = true;

            await network.sendChatMessage(order_id, user_id, user_name, text, 'text');
        }
    }
    const pressEnter = async (e) => {
        if (e.charCode === 13) {
            e.preventDefault();
            sendTextMessage();
        }
    }

    /*
     *       ,ww
     * wWWWWWWW_)
     * `WWWWWW'
     *  II  II
     *
     * костыль в шкурке овечки
     */
    const kostilFileOpen = (e) => {
        if ($axis) {
            e.preventDefault();

            let a;

            document.body.appendChild(a = document.createElement('a'));

            a.setAttribute('href', e.target.href);
            a.setAttribute('target', '_blank');
            a.dispatchEvent(new MouseEvent('click', {ctrlKey: true}));
            a.remove();
        }
    }
</script>

<TopMenu title="Сообщения по задаче #{id}">
    <Link to="/order/{id}" class="headerButton goBack" slot="left">
        <ion-icon name="chevron-back-outline" role="img" class="md hydrated" aria-label="chevron back outline"></ion-icon>
    </Link>
</TopMenu>

<div id="appCapsule">
    {#each Object.entries(_.groupBy(messages, 'date')) as [date, group]}
        <div class="message-divider">{date}</div>

        {#each group as item}
            <div class="message-item {+item.user === +$user.id ? 'user' : ''}">
                <div class="content">
                    <div class="title">{item.name}</div>

                    <div class="bubble">
                        {#if item.type === 'picture'}
                            <div class="row g-3">
                                {#each item.message.split(';') as attachment}
                                    <div class="col col-auto">
                                        <a href={attachment} target="_blank">
                                            <img src={attachment} class="imaged" style="width: auto; height: 100px; border-radius: 3px;" />
                                        </a>
                                    </div>
                                {/each}
                            </div>
                        {:else if item.type === 'file'}
                            {#each item.message.split(';') as attachment}
                                <div>
                                    <a href={attachment} target="_blank" on:click={kostilFileOpen}>
                                        <ion-icon name="cloud-download-outline" role="img" class="md hydrated"></ion-icon>
                                        {decodeURIComponent(attachment.split('/').pop()).replace(/-[a-f\d]+(?=\.)/i, '')}
                                    </a>
                                </div>
                            {/each}
                        {:else}
                            {item.message}
                        {/if}
                    </div>

                    <div class="footer">{item.time}</div>
                </div>
            </div>
        {/each}
    {/each}
</div>

<!-- Add Action Sheet -->
<div class="offcanvas offcanvas-bottom action-sheet inset" tabindex="-1" id="actionSheetAdd">
    <div class="offcanvas-header">
        <h5 class="offcanvas-title">Добавить</h5>
    </div>
    <div class="offcanvas-body">
        <ul class="action-button-list">
            <li>
                <label for="picture" class="btn btn-list" data-bs-dismiss="offcanvas">
                    <input type="file" id="picture" style="display: none;" on:change={sendAttachment} accept="image/*" multiple>
                    <span>
                        <ion-icon name="image-outline" role="img" class="md hydrated" aria-label="image outline"></ion-icon>
                        Картинка
                    </span>
                </label>
            </li>
            <li>
                <label for="file" class="btn btn-list" data-bs-dismiss="offcanvas">
                    <input type="file" id="file" style="display: none;" on:change={sendAttachment} accept=".doc,.docx,.xls,.xlsx,.pdf">
                    <span>
                        <ion-icon name="document-outline" role="img" class="md hydrated" aria-label="document outline"></ion-icon>
                        Файл
                    </span>
                </label>
            </li>
        </ul>
    </div>
</div>
<!-- * Add Action Sheet -->

<!-- chat footer -->
<div class="chatFooter">
    <a href="#" class="btn btn-icon btn-secondary rounded" data-bs-toggle="offcanvas" data-bs-target="#actionSheetAdd">
        <ion-icon name="add" role="img" class="md hydrated" aria-label="add"></ion-icon>
    </a>

    <div class="form-group boxed">
        <div class="input-wrapper">
            <input type="text" class="form-control" bind:value={text} disabled="{disabled}" on:keypress={pressEnter} placeholder="Ваше сообщение...">
        </div>
    </div>

    <button type="button" class="btn btn-icon btn-primary rounded" on:click={sendTextMessage}>
        {#if disabled}
            <ion-icon name="hourglass-outline" role="img" class="md hydrated"></ion-icon>
        {:else}
            <ion-icon name="send" role="img" class="md hydrated" aria-label="send"></ion-icon>
        {/if}
    </button>
</div>
<!-- * chat footer -->
